import { useEffect, useState } from "react";
import styles from "./assignToDriver.module.css";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { Button, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { authData } from "../../components/GetAuth";

export default function AssignedPopup({ setLoading, modalClose, bookingIds, onSubmit }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [driverList, setDriverList] = useState([]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/delivery/driver-dd-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const onSubmitLocal = (data) => {
    modalClose();
    setLoading(true);

    let postData = { driver_id: data?.driver_id, bookingIds: [bookingIds] };

    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/reassign-bookings", postData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        onSubmit(response.data.message);
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const unAssigned = () => {
    modalClose();
    setLoading(true);

    let postData = { bookingIds: [bookingIds] };

    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/unassign-bookings", postData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        onSubmit(response.data.message);
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<div className={`${styles.FullDiv}`}>
    <form onSubmit={handleSubmit(onSubmitLocal)}>
      <div className={`${styles.FormGroupFull}`}>
        <div className={`FormHalfGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Driver*</InputLabel>
            <Controller
              control={control}
              {...register("driver_id", { required: "Please select driver" })}
              render={({ field }) => (<Select {...field} label="Select Driver*">
                {driverList?.map((i) => {
                  return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
                })}
              </Select>)}
            />
          </FormControl>
          {errors.driver_id && (<span className={`ErrorM`}>{errors?.driver_id?.message}</span>)}
        </div>
      </div>
      <div className={`FormButtonArea`}>
        <Button className={`CancelBU`} onClick={(e) => unAssigned()}>Un-Assign</Button>
        <Button className={`SubmitBU`} type="submit">Re-Assign</Button>
      </div>
    </form>
  </div>);
}